<template>
  <div id="projects">
    <v-toolbar>
      <v-toolbar-title>
        <span>{{'kyc._kyc_list_'|translate}}: {{kyc.length}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
<!--        <download-excel
        class="btn btn-default"
        :data="kyc"
        :fields="json_fields"
        type="csv"
        name="kyc.csv"
      >
        <button type="button" class="mb-2 v-btn theme--dark primary">{{'general._ExporttoCSV_'|translate}}</button>
      </download-excel> -->
    </v-toolbar>
    
    <v-data-table
      :headers="headers"
      :items="kyc"
      :pagination.sync="pagination"
      :item-key="id"
      :loading="loading"
      class="elevation-1"
    >
     
      <template slot="items" slot-scope="props">
        <tr style="cursor: pointer">
          <td class="text-xs-left">{{ props.item.first_name }}</td>
          <td class="text-xs-left">{{ props.item.last_name }}</td>
          <td class="text-xs-left">
            <div v-viewer class="images clearfix">

              <template >
                <img :src="props.item.first_id.image_url" class="image" >
                </template>
            </div>
          </td>
            <td class="text-xs-left">
            <div v-viewer class="images clearfix">

              <template >
                <img :src="props.item.second_id.image_url" class="image" >
                </template>
            </div>
          </td>
                    <td class="text-xs-left">
            <div v-viewer class="images clearfix">

              <template >
                <img :src="props.item.address_id.image_url" class="image" >
                </template>
            </div>
          </td>
            <td class="text-xs-left">
            <v-btn @click.stop="deletekyc(props.item)" flat icon color="grey">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { db } from "@/api/firebaseInit";
import firebase from "firebase";
export default {


  name: "widget-nazih",
  data() {
    return {
      created_by_id:"",
      created_by:'',
      coupon_id:'',
      loading: true,
      pagination: {
        sortBy: "title",
        rowsPerPage: "100"
      },
      id: null,
          
      headers: [
        { text: this.$t('kyc._first_name_'), value: "first_name" },  
        { text: this.$t('kyc._last_name_'), value: "last_name" },
        { text: this.$t('kyc._first_id_'), value: "first_id" },
        { text: this.$t('kyc._second_id_'), value: "second_id" },
        { text: this.$t('kyc._address_id_'), value: "address_id" },
        { text: this.$t('coupons._Delete_'), value: "Delete" }
      ],
 /*      json_fields: {
        "Nom du Projet": "title",
        "Type de projet": "type",
        Déscription: "description",
        Statut: "status",
        "Crée par": "createdBy"
      } */
    };
  },
     computed: {
    kyc(){
      let kyc =  this.$store.getters.kyc;
        this.loading=false
      return kyc;
    }
  },
    watch: {
   kyc(){
      let kyc =  this.$store.getters.kyc;
       this.loading=false
      return kyc;
    }
  },
    created() {  
    this.created_by_id = firebase.auth().currentUser.uid;
     this.created_by = firebase.auth().currentUser.displayName;
  },
  mounted() {
    //this.FetchProjects();
  },
  methods: {
    deletekyc(kyc) {
      var that = this;
      if (confirm("Are you sure?")) {
        db.collection("kyc")
          .doc(kyc.id)
          .delete()
          .then(function() {
            alert(`kyc deleted succesuflly `);
           
          });
           this.$store.dispatch('fetchkyc')
           // this.$router.push({name: 'widget-coupons'});
      }
    },


  }
};
</script>
<style>
.image {
  height: 20px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/widgets/Kyc.vue